/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * qualiq-backend API
 * OpenAPI spec version: 1.0.0
 */
import { useInfiniteQuery, useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type { CatalogDTO, GetCatalogFilterParams } from ".././model";

import { customInstance } from "../../lib/api-client";

/**
 * @summary Get All
 */
export const getCatalog = (signal?: AbortSignal) => {
  return customInstance<CatalogDTO[]>({
    url: `/catalog`,
    method: "GET",
    signal,
  });
};

export const getGetCatalogInfiniteQueryKey = () => {
  return ["infinite", `/catalog`] as const;
};

export const getGetCatalogQueryKey = () => {
  return [`/catalog`] as const;
};

export const getGetCatalogInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getCatalog>>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseInfiniteQueryOptions<
      Awaited<ReturnType<typeof getCatalog>>,
      TError,
      TData
    >
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCatalogInfiniteQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCatalog>>> = ({
    signal,
  }) => getCatalog(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getCatalog>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCatalogInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCatalog>>
>;
export type GetCatalogInfiniteQueryError = void;

export function useGetCatalogInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCatalog>>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCatalog>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCatalog>>,
          TError,
          Awaited<ReturnType<typeof getCatalog>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCatalogInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCatalog>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCatalog>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCatalog>>,
          TError,
          Awaited<ReturnType<typeof getCatalog>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCatalogInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCatalog>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCatalog>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All
 */

export function useGetCatalogInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCatalog>>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCatalog>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCatalogInfiniteQueryOptions(options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetCatalogQueryOptions = <
  TData = Awaited<ReturnType<typeof getCatalog>>,
  TError = void,
>(options?: {
  query?: Partial<
    UseQueryOptions<Awaited<ReturnType<typeof getCatalog>>, TError, TData>
  >;
}) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCatalogQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCatalog>>> = ({
    signal,
  }) => getCatalog(signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCatalog>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCatalogQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCatalog>>
>;
export type GetCatalogQueryError = void;

export function useGetCatalog<
  TData = Awaited<ReturnType<typeof getCatalog>>,
  TError = void,
>(
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCatalog>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCatalog>>,
          TError,
          Awaited<ReturnType<typeof getCatalog>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCatalog<
  TData = Awaited<ReturnType<typeof getCatalog>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCatalog>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCatalog>>,
          TError,
          Awaited<ReturnType<typeof getCatalog>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCatalog<
  TData = Awaited<ReturnType<typeof getCatalog>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCatalog>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All
 */

export function useGetCatalog<
  TData = Awaited<ReturnType<typeof getCatalog>>,
  TError = void,
>(
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCatalog>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCatalogQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Create
 */
export const postCatalog = (catalogDTO: CatalogDTO, signal?: AbortSignal) => {
  return customInstance<CatalogDTO>({
    url: `/catalog`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: catalogDTO,
    signal,
  });
};

export const getPostCatalogMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof postCatalog>>,
    TError,
    { data: CatalogDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof postCatalog>>,
  TError,
  { data: CatalogDTO },
  TContext
> => {
  const mutationKey = ["postCatalog"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof postCatalog>>,
    { data: CatalogDTO }
  > = (props) => {
    const { data } = props ?? {};

    return postCatalog(data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PostCatalogMutationResult = NonNullable<
  Awaited<ReturnType<typeof postCatalog>>
>;
export type PostCatalogMutationBody = CatalogDTO;
export type PostCatalogMutationError = void;

/**
 * @summary Create
 */
export const usePostCatalog = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof postCatalog>>,
      TError,
      { data: CatalogDTO },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof postCatalog>>,
  TError,
  { data: CatalogDTO },
  TContext
> => {
  const mutationOptions = getPostCatalogMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get All By Filter
 */
export const getCatalogFilter = (
  params: GetCatalogFilterParams,
  signal?: AbortSignal,
) => {
  return customInstance<CatalogDTO[]>({
    url: `/catalog/filter`,
    method: "GET",
    params,
    signal,
  });
};

export const getGetCatalogFilterInfiniteQueryKey = (
  params?: GetCatalogFilterParams,
) => {
  return ["infinite", `/catalog/filter`, ...(params ? [params] : [])] as const;
};

export const getGetCatalogFilterQueryKey = (
  params?: GetCatalogFilterParams,
) => {
  return [`/catalog/filter`, ...(params ? [params] : [])] as const;
};

export const getGetCatalogFilterInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getCatalogFilter>>>,
  TError = void,
>(
  params: GetCatalogFilterParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCatalogFilter>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCatalogFilterInfiniteQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCatalogFilter>>
  > = ({ signal }) => getCatalogFilter(params, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getCatalogFilter>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCatalogFilterInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCatalogFilter>>
>;
export type GetCatalogFilterInfiniteQueryError = void;

export function useGetCatalogFilterInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCatalogFilter>>>,
  TError = void,
>(
  params: GetCatalogFilterParams,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCatalogFilter>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCatalogFilter>>,
          TError,
          Awaited<ReturnType<typeof getCatalogFilter>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCatalogFilterInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCatalogFilter>>>,
  TError = void,
>(
  params: GetCatalogFilterParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCatalogFilter>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCatalogFilter>>,
          TError,
          Awaited<ReturnType<typeof getCatalogFilter>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCatalogFilterInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCatalogFilter>>>,
  TError = void,
>(
  params: GetCatalogFilterParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCatalogFilter>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All By Filter
 */

export function useGetCatalogFilterInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCatalogFilter>>>,
  TError = void,
>(
  params: GetCatalogFilterParams,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCatalogFilter>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCatalogFilterInfiniteQueryOptions(params, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetCatalogFilterQueryOptions = <
  TData = Awaited<ReturnType<typeof getCatalogFilter>>,
  TError = void,
>(
  params: GetCatalogFilterParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCatalogFilter>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCatalogFilterQueryKey(params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getCatalogFilter>>
  > = ({ signal }) => getCatalogFilter(params, signal);

  return {
    queryKey,
    queryFn,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCatalogFilter>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCatalogFilterQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCatalogFilter>>
>;
export type GetCatalogFilterQueryError = void;

export function useGetCatalogFilter<
  TData = Awaited<ReturnType<typeof getCatalogFilter>>,
  TError = void,
>(
  params: GetCatalogFilterParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCatalogFilter>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCatalogFilter>>,
          TError,
          Awaited<ReturnType<typeof getCatalogFilter>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCatalogFilter<
  TData = Awaited<ReturnType<typeof getCatalogFilter>>,
  TError = void,
>(
  params: GetCatalogFilterParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCatalogFilter>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCatalogFilter>>,
          TError,
          Awaited<ReturnType<typeof getCatalogFilter>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCatalogFilter<
  TData = Awaited<ReturnType<typeof getCatalogFilter>>,
  TError = void,
>(
  params: GetCatalogFilterParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCatalogFilter>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get All By Filter
 */

export function useGetCatalogFilter<
  TData = Awaited<ReturnType<typeof getCatalogFilter>>,
  TError = void,
>(
  params: GetCatalogFilterParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCatalogFilter>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCatalogFilterQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Update
 */
export const putCatalogId = (id: number, catalogDTO: CatalogDTO) => {
  return customInstance<CatalogDTO>({
    url: `/catalog/${id}`,
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    data: catalogDTO,
  });
};

export const getPutCatalogIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof putCatalogId>>,
    TError,
    { id: number; data: CatalogDTO },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof putCatalogId>>,
  TError,
  { id: number; data: CatalogDTO },
  TContext
> => {
  const mutationKey = ["putCatalogId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof putCatalogId>>,
    { id: number; data: CatalogDTO }
  > = (props) => {
    const { id, data } = props ?? {};

    return putCatalogId(id, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type PutCatalogIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof putCatalogId>>
>;
export type PutCatalogIdMutationBody = CatalogDTO;
export type PutCatalogIdMutationError = void;

/**
 * @summary Update
 */
export const usePutCatalogId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof putCatalogId>>,
      TError,
      { id: number; data: CatalogDTO },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof putCatalogId>>,
  TError,
  { id: number; data: CatalogDTO },
  TContext
> => {
  const mutationOptions = getPutCatalogIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
/**
 * @summary Get By Id
 */
export const getCatalogId = (id: number, signal?: AbortSignal) => {
  return customInstance<CatalogDTO>({
    url: `/catalog/${id}`,
    method: "GET",
    signal,
  });
};

export const getGetCatalogIdInfiniteQueryKey = (id?: number) => {
  return ["infinite", `/catalog/${id}`] as const;
};

export const getGetCatalogIdQueryKey = (id?: number) => {
  return [`/catalog/${id}`] as const;
};

export const getGetCatalogIdInfiniteQueryOptions = <
  TData = InfiniteData<Awaited<ReturnType<typeof getCatalogId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCatalogId>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetCatalogIdInfiniteQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCatalogId>>> = ({
    signal,
  }) => getCatalogId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseInfiniteQueryOptions<
    Awaited<ReturnType<typeof getCatalogId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCatalogIdInfiniteQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCatalogId>>
>;
export type GetCatalogIdInfiniteQueryError = void;

export function useGetCatalogIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCatalogId>>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCatalogId>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCatalogId>>,
          TError,
          Awaited<ReturnType<typeof getCatalogId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCatalogIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCatalogId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCatalogId>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCatalogId>>,
          TError,
          Awaited<ReturnType<typeof getCatalogId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCatalogIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCatalogId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCatalogId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get By Id
 */

export function useGetCatalogIdInfinite<
  TData = InfiniteData<Awaited<ReturnType<typeof getCatalogId>>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseInfiniteQueryOptions<
        Awaited<ReturnType<typeof getCatalogId>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseInfiniteQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCatalogIdInfiniteQueryOptions(id, options);

  const query = useInfiniteQuery(
    queryOptions,
    queryClient,
  ) as UseInfiniteQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetCatalogIdQueryOptions = <
  TData = Awaited<ReturnType<typeof getCatalogId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCatalogId>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCatalogIdQueryKey(id);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCatalogId>>> = ({
    signal,
  }) => getCatalogId(id, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!id,
    staleTime: 10000,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCatalogId>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCatalogIdQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCatalogId>>
>;
export type GetCatalogIdQueryError = void;

export function useGetCatalogId<
  TData = Awaited<ReturnType<typeof getCatalogId>>,
  TError = void,
>(
  id: number,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCatalogId>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCatalogId>>,
          TError,
          Awaited<ReturnType<typeof getCatalogId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCatalogId<
  TData = Awaited<ReturnType<typeof getCatalogId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCatalogId>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCatalogId>>,
          TError,
          Awaited<ReturnType<typeof getCatalogId>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCatalogId<
  TData = Awaited<ReturnType<typeof getCatalogId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCatalogId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get By Id
 */

export function useGetCatalogId<
  TData = Awaited<ReturnType<typeof getCatalogId>>,
  TError = void,
>(
  id: number,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getCatalogId>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCatalogIdQueryOptions(id, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * @summary Delete
 */
export const deleteCatalogId = (id: number) => {
  return customInstance<boolean>({ url: `/catalog/${id}`, method: "DELETE" });
};

export const getDeleteCatalogIdMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteCatalogId>>,
    TError,
    { id: number },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteCatalogId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationKey = ["deleteCatalogId"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCatalogId>>,
    { id: number }
  > = (props) => {
    const { id } = props ?? {};

    return deleteCatalogId(id);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteCatalogIdMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCatalogId>>
>;

export type DeleteCatalogIdMutationError = void;

/**
 * @summary Delete
 */
export const useDeleteCatalogId = <TError = void, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteCatalogId>>,
      TError,
      { id: number },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof deleteCatalogId>>,
  TError,
  { id: number },
  TContext
> => {
  const mutationOptions = getDeleteCatalogIdMutationOptions(options);

  return useMutation(mutationOptions, queryClient);
};
